import { useQueries, useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CourtAvailabilityDto } from "../../../models/court/dto/court-availability.dto";
import { CourtDto } from "../../../models/court/dto/court.dto";
import { GetCourtCalendarOutputDto } from "../../../models/court/dto/get-court-calendar.dto";
import { GameDto } from "../../../models/game/dto/game.dto";

export const GET_COURT_CALENDER_QUERY_KEY = (id: number, start: Date, end: Date) => ['courtCalendar', id, start, end];
export const useGetCourtCalendar = (id: number, start: Date, end: Date, enabled = true) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: GET_COURT_CALENDER_QUERY_KEY(id, start, end),
        queryFn: () => apiClient.fetchApi<GetCourtCalendarOutputDto, {}>({
            endpoint: `courts/${id}/calendar/${start.toISOString()}/${end.toISOString()}`,
            method: 'GET',
        }),
        // Both of today's callers already pass a validity flag
        // (`isValidCourtId`, `selectedCourt > 0`) because a missing `?court=`
        // makes `Number.parseInt` return NaN and `courts/NaN/...` 500'd the
        // page (MYSPORTSET-API-E9 / -EA). Keeping that at the call site only
        // means the third caller has to remember; the id check belongs with
        // the id.
        enabled: enabled && Number.isInteger(id),
    });
}
export const useGetCourtsCalendar = (ids: number[], start: Date, end: Date) => {
    const apiClient = useApiClient();
    return useQueries({
        queries: ids.map(id => ({
            staleTime: 5000,
            queryKey: GET_COURT_CALENDER_QUERY_KEY(id, start, end),
            queryFn: () => apiClient.fetchApi<GetCourtCalendarOutputDto, {}>({
                endpoint: `courts/${id}/calendar/${start.toISOString()}/${end.toISOString()}`,
                method: 'GET',
            })
        }))
    });
};

export const useGetCourtWeeklyCalendar = (courtId: number, dates: Date[]) => {
    const apiClient = useApiClient();
    return useQueries({
        queries: dates.map(date => {
            const end = new Date(date.getTime() + 24 * 60 * 60 * 1000 - 0);
            return {
                queryKey: ['courtCalendar', courtId, date],
                queryFn: () => apiClient.fetchApi<{ games: GameDto[]; availabilities: CourtAvailabilityDto[]; court: CourtDto }, {}>({
                    endpoint: `courts/${courtId}/calendar/${date.toISOString()}/${end.toISOString()}`,
                    method: 'GET',
                })
            }
        })
    });
};